import { Component } from '@angular/core';
import { NavController, LoadingController, ToastController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../../../../globals';
import { ConfigurationServices } from '../../../services';
import { ConfigurationThermalPrintersPage } from '../../configuration-thermal-printers';
import { PrintServices } from '../../../../services/printServices';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-configuration-printers-wizard-list',
  templateUrl: 'configuration-printers-wizard-list.html'
})

export class ConfigurationPrintersWizardListPage {

  printer: any;

  constructor(public navCtrl: NavController,
    public globals: Globals,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    public printServices: PrintServices,
    private configurationServices: ConfigurationServices,
    private toastCtrl: ToastController,
    public translate: TranslateService) {
    this.printServices.list_printers = null;
    this.printServices.findAllPrinter();
    }

  setDefault(name) {
    for (let printer of this.printServices.list_printers) {
      if (printer.modelName == name) {
        this.printer = printer;
        printer.default = true;
      } else {
        printer.default = false;
      }
    }
  }

  finish() {

    if (this.printer) {
      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: this.translate.instant('instant-anadiendo')
      });
      loadingPopup.present();
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'printer_type':'starprnt',
        'starprnt_cashdrawer': false,
        'starprnt_portName': this.printer.portName,
      }).then(doc => {
        this.globals.restaurant.printer_type = 'starprnt'
        this.globals.restaurant.starprnt_cashdrawer = false;
        this.globals.restaurant.starprnt_portName = this.printer.portName,
          //
          loadingPopup.dismiss();
          //this.navCtrl.push(ConfigurationThermalPrintersPage);
          this.navCtrl.push(ConfigurationThermalPrintersPage).then(() => {
            let index = 1;
            this.navCtrl.remove(index);
          });
      }).catch(error => {
        loadingPopup.dismiss();
      })
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-una-impresora'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }

  }

  stringContains(str, text) {
    return str.toLowerCase().includes(text.toLowerCase())
  }


}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-thermal-printers/configuration-printers-wizard/configuration-printers-wizard-list/configuration-printers-wizard-list.ts